import React from 'react';
import Icon from '../../../components/AppIcon';

const CohortAnalysis = ({ cohorts }) => {
  const getRetentionColor = (rate) => {
    if (rate >= 80) return 'bg-success';
    if (rate >= 60) return 'bg-accent';
    if (rate >= 40) return 'bg-warning';
    return 'bg-error';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-card-foreground">Cohort Analysis</h3>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Users" size={16} />
          <span>User Retention by Registration Month</span>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="px-4 py-3 text-left text-sm font-semibold text-muted-foreground">Cohort</th>
              <th className="px-4 py-3 text-center text-sm font-semibold text-muted-foreground">Users</th>
              <th className="px-4 py-3 text-center text-sm font-semibold text-muted-foreground">Week 1</th>
              <th className="px-4 py-3 text-center text-sm font-semibold text-muted-foreground">Week 2</th>
              <th className="px-4 py-3 text-center text-sm font-semibold text-muted-foreground">Week 3</th>
              <th className="px-4 py-3 text-center text-sm font-semibold text-muted-foreground">Week 4</th>
              <th className="px-4 py-3 text-center text-sm font-semibold text-muted-foreground">Avg Engagement</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {cohorts?.map((cohort) => (
              <tr key={cohort?.month} className="hover:bg-muted/50 transition-colors">
                <td className="px-4 py-3 text-sm font-medium text-card-foreground">{cohort?.month}</td>
                <td className="px-4 py-3 text-sm text-center text-card-foreground">{cohort?.users}</td>
                <td className="px-4 py-3">
                  <div className="flex items-center justify-center gap-2">
                    <div className={`w-16 h-6 rounded ${getRetentionColor(cohort?.week1)} flex items-center justify-center`}>
                      <span className="text-xs font-semibold text-white">{cohort?.week1}%</span>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center justify-center gap-2">
                    <div className={`w-16 h-6 rounded ${getRetentionColor(cohort?.week2)} flex items-center justify-center`}>
                      <span className="text-xs font-semibold text-white">{cohort?.week2}%</span>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center justify-center gap-2">
                    <div className={`w-16 h-6 rounded ${getRetentionColor(cohort?.week3)} flex items-center justify-center`}>
                      <span className="text-xs font-semibold text-white">{cohort?.week3}%</span>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center justify-center gap-2">
                    <div className={`w-16 h-6 rounded ${getRetentionColor(cohort?.week4)} flex items-center justify-center`}>
                      <span className="text-xs font-semibold text-white">{cohort?.week4}%</span>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center justify-center gap-2">
                    <span className="text-sm font-semibold text-card-foreground">{cohort?.avgEngagement}%</span>
                    <Icon 
                      name={cohort?.avgEngagement >= 70 ? 'TrendingUp' : cohort?.avgEngagement >= 50 ? 'Minus' : 'TrendingDown'} 
                      size={14} 
                      className={cohort?.avgEngagement >= 70 ? 'text-success' : cohort?.avgEngagement >= 50 ? 'text-accent' : 'text-error'}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-6 p-4 bg-muted rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-accent flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-card-foreground mb-1">Understanding Cohort Analysis</p>
            <p className="text-sm text-muted-foreground">
              This table shows user retention rates by registration month. Each cell represents the percentage of users from that cohort who remained active during the specified week. Higher retention rates indicate better user engagement and platform stickiness.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CohortAnalysis;